<template>
  <div class="logs page">
    <div class="body">
      <ActionDetailModal @quit="closeModal" v-if="openModal" :data="modalData" />
      <ActionOtherModal  @quit="closeModal" :title="otherModalTitle" v-if="openOtherModal" :modalData="otherModalData" />
      <ZSearchForm style="width: 100%" :searchOption="searchOption" @search="handleSearch" />
      <a-spin style="width:100%" :spinning="loading">
        <a-table class="table" :pagination="pagination" :columns="columns" :dataSource="logs" @change="pageChange">
          <template slot="content" slot-scope="text">
            <!-- <div v-if="text.length > 60" @click="toggleShow" class="long-text">{{expand ? text : text.slice(0, 57) + '...'}}</div> -->
            <a-tooltip v-if="text.length > 40"  placement="top">
              <template slot="title">
                <span>{{text}}</span>
              </template>
              <div class="long-text">{{text.slice(0, 40) + '...'}}</div>
            </a-tooltip>
            <div v-else>{{text}}</div>
          </template>
          <template slot="detail" slot-scope="text, record">
            <a-button-group v-if="text && record.type === '设备'">
              <a-button @click="showDetail(text, record)" type="primary"><zx-icon type="icon-jsearch"></zx-icon>{{ $t('log.details')}}</a-button>
              <a-button @click="exportExcel(text, record)" type="primary"><zx-icon type="icon-daochu"></zx-icon>{{ $t('log.export')}}</a-button>
            </a-button-group>
            <a-button size="small" @click="showOtherModal(text, record)" v-if="text && record.type !== '设备'" type="primary">{{ $t('log.details')}}</a-button>
          </template>
        </a-table>
      </a-spin>
    </div>
  </div>
</template>
<script>
  // import QuerySelect from './QuerySelect'
  import ZSearchForm from '@/components/common/SearchForm'
  import ActionDetailModal from './actionDetailModal'
  import config from '../../config'
  import {export_json_to_excel} from '../../utils/Export2Excel'
  import moment from 'moment'
  import {mapGetters} from 'vuex'
  export default {
    components: {
      ActionDetailModal,
      ZSearchForm,
      ActionOtherModal: () => import('./actionOtherModal')
    },
    computed: {
      ...mapGetters(['roles']),
      columns () {
        return [{
            title: this.$t('log.logsBelong'),
            dataIndex: 'name',
            // sorter: (a, b) => a.oui.length - b.oui.length,
          },
          {
            title: this.$t('log.recorder'),
            dataIndex: 'user_name',
            // sorter: (a, b) => a.oui.length - b.oui.length,
          },
          {
            title: this.$t('log.logType'),
            dataIndex: 'type',
            // sorter: (a, b) => a.description.length - b.description.length,
          },
          {
            title: this.$t('log.loginType'),
            dataIndex: 'opt_entrance',
            // sorter: (a, b) => a.description.length - b.description.length,
          },
          {
            title: this.$t('log.content'),
            dataIndex: 'content',
            scopedSlots: {
              "customRender": "content"
            }
            // sorter: (a, b) => a.description.length - b.description.length,
          },
          {
            title: this.$t('global.time'),
            dataIndex: 'timestamp',
            customRender: (text) => {
              // console.log(data)
              let now = moment().unix()
              if (now - text > 24 * 60 * 60 * 2) {
                return moment(text * 1000).format('YYYY-MM-DD HH:mm')
              } else {
                return moment(text * 1000).fromNow()
              }
              // return moment(text * 1000).format('YYYY-MM-DD HH:mm')
            },
            // sorter: (a, b) => a.timestamp - b.timestamp,
          },
          {
            title: this.$t('global.alarmAction'),
            dataIndex: 'detail',
            scopedSlots: {
              "customRender": "detail"
            }
            // sorter: (a, b) => a.description.length - b.description.length,
          },
        ]
      }
      // 用计算属性会覆盖值
      // searchOption () {
      //   let customSearchOption = [
      //     {
      //       key: "link",
      //       name: "所属机构",
      //       type: "orgChooser",
      //       matchType: "ll",
      //       option: {
      //         showDirect: this.roles === 'Integrator' ? false : true,
      //         directFlag: this.roles === 'Integrator' ? false : true,
      //         value: ""
      //       }
      //     },
      //     {
      //       key: "type",
      //       name: "日志类型",
      //       type: "selector",
      //       placeholder: '请选择日志类型',
      //       value: undefined,
      //       source: []
      //     },
      //     {
      //       key: "entrance",
      //       name: "登录方式",
      //       type: "selector",
      //       placeholder: '请选择登录方式',
      //       value: undefined,
      //       source: [{
      //           name: 'web',
      //           value: 'web'
      //         },
      //         {
      //           name: 'app',
      //           value: 'app'
      //         }
      //       ]
      //     },

      //     {
      //       key: "dimMatch",
      //       name: "模糊查询",
      //       type: "input",
      //       value: "",
      //       placeholder: '请输入要查询的内容',
      //       default: true
      //     },
      //     {
      //       key: "createTime",
      //       name: "发生时间",
      //       type: "custom",
      //       placeholder: '选择时间',
      //       matchValue: undefined,
      //       dataType: "time",
      //       searchTypeData: [{
      //           key: "之后",
      //           type: "datePicker",
      //           paramName: "startTime",
      //           value: null
      //         },
      //         {
      //           key: "之前",
      //           type: "datePicker",
      //           paramName: "endTime",
      //           value: null
      //         },
      //         {
      //           key: "之间",
      //           type: "rangePicker",
      //           paramName: "startTime,endTime",
      //           value: []
      //         }
      //       ]
      //     }
      //   ]
      //   return customSearchOption
      // }
    },
    data() {
      return {
        openModal: false,
        otherModalData: '',
        openOtherModal: false,
        otherModalTitle: '',
        modalData: '',
        expand: false,
        loading: false,
        queryParams: {},
        queryTypes: [],
        logs: [],
        pagination: {
          // showSizeChanger: true,
          // pageSizeOptions:['2','10','50','100'],
          pageSize: 10,
          current: 1,
          total: 0,
          showTotal: '',
          showQuickJumper: true,
          size: 'small',
          // position: 'both'
        },
        searchOption: [
          {
            key: "link",
            name: "所属机构",
            type: "orgChooser",
            matchType: "ll",
            option: {
              showDirect: true,
              directFlag: true,
              value: ""
            }
          },
          {
            key: "type",
            name: "日志类型",
            type: "selector",
            placeholder: '请选择日志类型',
            value: undefined,
            source: []
          },
          {
            key: "entrance",
            name: "登录方式",
            type: "selector",
            placeholder: '请选择登录方式',
            value: undefined,
            source: [{
                name: 'web',
                value: 'web'
              },
              {
                name: 'app',
                value: 'app'
              }
            ]
          },

          {
            key: "dimMatch",
            name: "模糊查询",
            type: "input",
            value: "",
            placeholder: '请输入要查询的内容',
            default: true
          },
          {
            key: "createTime",
            name: "发生时间",
            type: "custom",
            placeholder: '选择时间',
            matchValue: undefined,
            dataType: "time",
            searchTypeData: [{
                key: "之后",
                type: "datePicker",
                paramName: "startTime",
                value: null
              },
              {
                key: "之前",
                type: "datePicker",
                paramName: "endTime",
                value: null
              },
              {
                key: "之间",
                type: "rangePicker",
                paramName: "startTime,endTime",
                value: []
              }
            ]
          }
        ],
      }
    },
    created() {
      this.getQueryTypes()
      this.querySystemLogs()
    },
    methods: {
      setSearchOption () {
        if (this.roles === 'Integrator') {
          this.searchOption[0].option.showDirect = false
          this.searchOption[0].option.directFlag = false
        }
      },
      parseText (text) {
        if (text && typeof text === 'string') {
          let arr1 = text.split(';')
          arr1.pop()
          // console.log(arr1)
          let arr2 = arr1.map((item) => {
            if (item.indexOf(',') === -1) {
              return [item]
            } else {
              return item.split(',')
            }
          })
          let titles = arr2[0]
          // let 
          return {
            titles,
            data: arr2.slice(1)
          }
        }
      },
      // 显示操作的详情
      showDetail (text, record) {
        // console.log(this.parseText(text))
        let name = moment(record.timestamp * 1000).format('YYYY-MM-DD HH:mm') + record.content
        this.modalData = Object.assign(this.parseText(text), {name})
        this.openModal = true
      },
      showOtherModal (text, record) {
        // console.log(text)
        this.otherModalTitle = moment(record.timestamp * 1000).format('YYYY-MM-DD HH:mm') + record.content
        this.otherModalData = text
        this.openOtherModal = true
      },
      closeModal () {
        this.modalData = ''
        this.openModal = false
        this.openOtherModal = false
        this.otherModalData = ''
      },
      exportExcel (text, record) {
        // console.log(record)
        let data = this.parseText(text)
        let name = moment(record.timestamp * 1000).format('YYYY-MM-DD HH:mm') + record.content
        export_json_to_excel(data.titles, data.data, name)
      },
      handleSearch(params) {
        params['matchType'] = params.orgMatchType
        params['currentPage'] = 1
        // console.log(params)
        this.queryParams = Object.assign({}, params)
        this.querySystemLogs(this.queryParams)
      },
      // 获取所有查询类别
      getQueryTypes() {
        this.$http.get(config.api.get_query_logs_type).then((res) => {
          // console.log(res)
          let {
            code,
            result
          } = res
          if (code === 0) {
            this.searchOption[1].source = result.map((item) => {
              return {
                name: item,
                value: item
              }
            })
            // console.log(this.queryTypes)
          }
        })
      },
      // 查询系统日志
      querySystemLogs(params={}) {
        // console.log(params)
        this.loading = true
        this.$http.post(config.api.post_system_logs, params).then((res) => {
          // console.log(res)
          let {
            code,
            result
          } = res
          let {
            page,
            resultList
          } = result
          if (code === 0) {
            this.pagination.current = page.currentPage
            this.pagination.total = page.totalSize
            this.pagination.showTotal = () => this.$t('global.totalRecords', {num : page.totalSize})
            this.logs = resultList
          }
          this.loading = false
        })
      },
      // showTotal () {
      //   return `共${this.logs.length}条操作日志`
      // },
      pageChange(page) {
        this.queryParams = Object.assign({}, this.queryParams, {
          currentPage: page.current,
          pageSize: 10
        })
        // console.log(params)
        this.pagination.current = page.current
        this.querySystemLogs(this.queryParams)
      }
    },
    mounted () {
      // console.log(this.roles)
      this.setSearchOption()
    }
  }
</script>
<style lang="less" scoped>
  @import '../../theme/page.less';
  .logs {
    width: 100vw;
    height: 93.5vh;
    // background-color: #fff;
    margin: 0 auto;
    // padding: 10px 20px;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    .body {
      // background-color: #fff;
      width: 100%;
      // margin: 20px;
      // margin: 10px 0;
      padding-bottom: 0; 
      box-sizing: border-box;
      .table {
        .content;
        padding: 10px;
        width: 100%;
        .long-text {
          max-width: 50%;
          cursor: pointer;
          // color: #1890ff;
        }
      }
    }
  }
</style>